<template>
  <v-layout row>
    <v-flex xs12>
      <v-toolbar color="blue-grey">
        <v-toolbar-title>Challenges</v-toolbar-title>
        <!--
        <v-spacer></v-spacer>
        <v-btn icon>
          <v-icon>search</v-icon>
        </v-btn>
        -->
      </v-toolbar>
      <v-card>
        <v-list two-line>
          <template v-for="(item, index) in items">
            <v-list-tile
              :key="item.id"
              avatar
              @click="getChallenge(item.id)"
            >
              <v-list-tile-avatar>
                <v-badge
                  overlap
                  :color="item.posts > 0 ? 'blue' : 'grey'"
                >
                  <span slot="badge">{{ item.points }}</span>
                  <v-icon
                    large
                    :color="item.posts > 0 ? 'yellow darken-2' : 'grey darken-1'"
                  >
                    star
                  </v-icon>
                </v-badge>
              </v-list-tile-avatar>
              <v-list-tile-content>
                <v-list-tile-title v-html="item.category"></v-list-tile-title>
                <v-list-tile-sub-title v-html="item.challenge"></v-list-tile-sub-title>
              </v-list-tile-content>
              <v-list-tile-action>
                <v-badge
                  overlap
                  :color="item.posts > 0 ? 'orange' : 'grey'"
                >
                  <span slot="badge">{{ item.posts }}</span>
                  <v-icon
                    large
                    :color="item.posts > 0 ? 'teal' : 'grey darken-1'"
                  >
                    chat_bubble
                  </v-icon>
                </v-badge>
              </v-list-tile-action>
            </v-list-tile>
            <v-divider v-if="index + 1 < items.length" :key="`divider-${index}`"></v-divider>
          </template>
        </v-list>
        <v-snackbar
          v-model="snackbar"
          :color="error"
          :timeout="10000"
          :top="true"
        >
          {{ error }}
          <v-btn
            dark
            flat
            @click="snackbar = false"
          >
            Close
          </v-btn>
        </v-snackbar>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
  export default {
    props: ['category'],
    data () {
      return {
        snackbar: false,
        error: "",
        challenges: [],
        items: []
      }
    },
    methods: {
      getChallenge (id) {
        this.$router.push({
          name: 'challengeDetails',
          query: {
            id: id
          }
        });
      },
      populateItems () {
        this.challenges.map((challenge, idx) => {
          let item = {
            id: challenge.id,
            example: 'img/challenge.png',
            category: '',
            challenge: challenge.challenge,
            posts: challenge.posts.length,
            points: challenge.points
          };
          let categories = [];

          challenge.categories.map((category, idx) => {
            categories.push(category.title);
          });

          item.category = categories.join(', ');

          if (challenge.examples.length == 1) {
            item.example = challenge.examples[0].url;
          }
          else if (challenge.examples.length > 0) {
            let min = 0, max = challenge.examples.length - 1;
            let random = Math.floor(Math.random() * (+max - +min)) + +min;

            item.example = challenge.examples[random].url;
          }

          this.items.push(item);
        });
      }
    },
    created () {
      this.$http.api.checkLogin();
    },
    mounted () {
      const url = this.category ? `/challenges/category/${this.category}` : '/challenges';

      this.$http.api.get(url)
      .then(response => {
        this.challenges = response.data;

        this.populateItems();
      })
      .catch(error => {
        if (error.response) {
          this.error = this.$http.api.getError(error).toString;
          this.snackbar = true;
        }
        else {
          console.dir(error);
        }
      });
    }
  }
</script>